import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { FaqModel } from 'src/app/shared/models/faq.model';
import { TranslatedObject } from 'src/app/shared/models/translated-object.model';
import { FeedbackService } from 'src/app/shared/services';
import { PublicFeedbackService } from 'src/app/shared/services/public-feedback.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  results: Array<FaqModel>;
  currentLang: string = '';

  constructor(
    private publicFeedbackService: PublicFeedbackService,
    private feedbackService: FeedbackService,
    private translateService: TranslateService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.currentLang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event: LangChangeEvent) => { this.currentLang = event.lang; });
    this.publicFeedbackService.getFaq()
      .subscribe(
        res => this.results = res.items,
        (err: HttpErrorResponse) => {
          this.feedbackService.handleError(err);
        }
      );
  }

  getTranslationText(object: TranslatedObject) {
    switch (this.currentLang) {
      case 'ru': return object.ru;
      case 'en': return object.en;
      case 'ro': return object.ro;
      default: return '';
    }
  }

  getAnswerHtml(answer: TranslatedObject) {
    return this.sanitizer.bypassSecurityTrustHtml(this.getTranslationText(answer));
  }
}
